import Papa from "papaparse";
import * as XLSX from "xlsx";
import {
  displayMemberEmail, resolveReportingManagers, formatManagerName, roleLabel,
} from "../screens/team/teamHelpers";

function getManagerIds(member) {
  const ids = new Set();
  (member?.reportingManagers || []).forEach((m) => {
    if (typeof m === "object") {
      const id = m._id || m.id;
      if (id) ids.add(String(id));
    } else if (m) ids.add(String(m));
  });
  if (member?.reportingManager) {
    const rm = member.reportingManager;
    if (typeof rm === "object") {
      const id = rm._id || rm.id;
      if (id) ids.add(String(id));
    } else ids.add(String(rm));
  }
  return ids;
}

export function memberReportsTo(member, managerId) {
  if (!member || !managerId) return false;
  return getManagerIds(member).has(String(managerId));
}

export function getMembersReportingTo(managerId, allUsers = []) {
  if (!managerId) return [];
  const mid = String(managerId);
  return allUsers.filter((u) => memberReportsTo(u, mid));
}

export function buildMemberExportRows(members = [], roles = [], allUsersForLookup = members) {
  return members.map((u) => {
    const reportingManagers = resolveReportingManagers(u, allUsersForLookup);
    const activated = u.isActivated;
    return {
      "First Name": u.firstName || "",
      "Last Name": u.lastName || "",
      Email: displayMemberEmail(u),
      "Login Email": u.stubEmail && u.email ? u.email : "",
      Role: roleLabel(roles, u.role),
      Position: u.position || "",
      Department: u.department || "",
      "Reporting Managers": reportingManagers.map(formatManagerName).join(", "),
      "Stealth Mode": u.stealth_mode ? "Yes" : "No",
      Status: activated === true ? "Active" : activated === false ? "Inactive" : "",
      "Desktop Agent": u.hasDesktopAgent
        ? "Yes"
        : u.latestAppVersion
          ? `v${u.latestAppVersion}`
          : "",
    };
  });
}

function exportFilename(ext) {
  const ts = new Date().toISOString().replace(/[:.]/g, "-").slice(0, -5);
  return `team_members_export_${ts}.${ext}`;
}

export function exportMembersCsv(rows) {
  const csv = Papa.unparse(rows, { header: true });
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", exportFilename("csv"));
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportMembersXlsx(rows) {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 14 }, { wch: 14 }, { wch: 28 }, { wch: 28 }, { wch: 14 },
    { wch: 22 }, { wch: 18 }, { wch: 30 }, { wch: 12 }, { wch: 10 }, { wch: 14 },
  ];
  XLSX.utils.book_append_sheet(wb, ws, "Team Members");
  XLSX.writeFile(wb, exportFilename("xlsx"));
}
